module.exports = __webpack_public_path__ + "img/pause.415a7c2f.png";